import { privateApi } from 'services';
import { ContentLibraryHeadline, CreateContentLibraryHeadline } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchHeadlines = async (businessAccountId: string): Promise<ContentLibraryHeadline[]> =>
    privateApi.get<ContentLibraryHeadline[]>(`business-accounts/${businessAccountId}/content-library/headline-items`);

const createHeadline = async (
    payload: CreateContentLibraryHeadline,
    businessAccountId: string,
): Promise<ContentLibraryHeadline> =>
    privateApi.post<ContentLibraryHeadline>(
        `business-accounts/${businessAccountId}/content-library/headline-items`,
        payload,
    );

const createHeadline2 = async (
    businessAccountId: string,
    formData: FormData,
    onProgressChange?: (e: ProgressEvent<XMLHttpRequestEventTarget>) => void,
): Promise<unknown> =>
    privateApi.postMultipart(
        `business-accounts/${businessAccountId}/content-library/headline-items`,
        formData,
        false,
        onProgressChange,
    );

const updateHeadlineStatus = async (headlineId: string, isArchived: boolean): Promise<ContentLibraryHeadline> =>
    privateApi.put<ContentLibraryHeadline>(`content-library/headline-items/${headlineId}`, {
        archived: isArchived,
    });

export const ContentLibraryHeadlineGateway = {
    fetchHeadlines,
    createHeadline,
    createHeadline2,
    updateHeadlineStatus,
};

const cancelableFetchHeadlines = async (businessAccountId: string): Promise<ContentLibraryHeadline[]> =>
    privateApiWithRouteLeavingCancelation.get<ContentLibraryHeadline[]>(
        `business-accounts/${businessAccountId}/content-library/headline-items`,
    );

export const CancelableContentLibraryHeadlineGateway = {
    cancelableFetchHeadlines,
};
